import { parsePhoneNumber, PhoneNumber } from "libphonenumber-js";

export function phoneToHuman(phoneNumber: string): string {
  try {
    // Parse the phone number
    const parsedNumber: PhoneNumber = parsePhoneNumber(phoneNumber);

    // Format to national format with parentheses and dashes (US style)
    if (parsedNumber.country === "US") {
      return parsedNumber.format("NATIONAL");
    }

    // For non-US numbers, still try to format in national style
    return parsedNumber.format("NATIONAL");
  } catch (error) {
    // Return original if parsing fails
    console.error("Error parsing phone number:", error);
    return phoneNumber;
  }
}
